
<!-- HTML Template -->
<template>
    <div>
        <v-container grid-list-lg>
            <v-layout row>
                <v-flex grow>
                    <v-text-field 
                        :label="label"
                        @click='onPickFile'
                        v-model='fileName'
                        prepend-icon="attach_file"
                    ></v-text-field>
                </v-flex>
                <v-flex shrink>
                    <v-btn v-if="filePath" icon v-bind:href="filePath" target="_blank">
                        <v-icon color="blue darken-1">description</v-icon>
                    </v-btn>
                </v-flex>

                
                <!-- Hidden -->
                <input
                    type="file"
                    style="display: none"
                    ref="fileInput"
                    accept="image/png, image/gif, image/jpeg, application/pdf"
                    @change="onFilePicked">
            </v-layout>
            
        </v-container>
    </div>
</template>

<!-- Javascript -->
<script>
    export default {
        name: 'File',
        data(){
            return {
                fileName: '',
                image: null,
            }
        },

        props: {
            label: {
                type: String,
                default: 'ficheiro',
            },
            filePath: String,
        },

        methods: {
            onPickFile () {
                this.$refs.fileInput.click()
            },
            onFilePicked (e) {
                const file = Array.from(e.target.files)[0];
                this.fileName = file.name;
                if(!file) return;
                if(!file.type.match('image.*')){
                    this.consoleLog('file is not an image');
                    return;
                }
                let reader = new FileReader();

                this.file = file;

                let vm = this;
                reader.onload = (e) => {
                    vm.image = e.target.result;
                    this.$emit('onFileDone', this.image);
                };
                reader.readAsDataURL(file);
            },
        }

    }
</script>

<!-- SASS styling -->
<style lang="scss">
</style>